// Opciones y utilidades del módulo "Trabaja con nosotros" (afiliación de
// propietarios, conductores y empresas de transporte de AXONIA GROUP).

export const affiliateTypeOptions = [
  {
    value: "independiente",
    label: "Propietario / Transportista independiente",
    description:
      "Registra tus datos y uno o varios vehículos propios para operar con AXONIA GROUP.",
    icon: "ri-user-star-line",
  },
  {
    value: "empresa",
    label: "Empresa de transporte",
    description:
      "Registra tu empresa y tu flota completa con toda la documentación de cada unidad.",
    icon: "ri-building-2-line",
  },
] as const;

export const rolVehiculoOptions = [
  { value: "propietario", label: "Propietario" },
  { value: "conductor", label: "Conductor" },
  { value: "ambos", label: "Propietario y conductor" },
];

export const provinciasRD = [
  "Distrito Nacional",
  "Santo Domingo",
  "Santiago",
  "La Vega",
  "San Cristóbal",
  "Puerto Plata",
  "Duarte",
  "Espaillat",
  "La Romana",
  "San Pedro de Macorís",
  "Peravia",
  "Azua",
  "Barahona",
  "Valverde",
  "Monseñor Nouel",
  "Sánchez Ramírez",
  "María Trinidad Sánchez",
  "Sam",
  "Hermanas Mirabal",
  "Monte Plata",
  "Hato Mayor",
  "El Seibo",
  "Monte Cristi",
  "Dajabón",
  "Santiago Rodríguez",
  "San Juan",
  "Elías Piña",
  "Independencia",
  "Pedernales",
  "Bahoruco",
  "San José de Ocoa",
  "Samaná",
];

export const tiposVehiculoOptions = [
  "Camión de mudanza",
  "Camión de carga",
  "Camión de reparto",
  "Camioneta",
  "Van",
  "Furgón",
  "Autobús",
  "Minibús",
  "Vehículo especial",
  "Otro",
];

export const tiposCargaAffiliateOptions = [
  "Muebles y enseres",
  "Equipos y maquinaria",
  "Materiales de construcción",
  "Mercadería y paquetes",
  "Producción de eventos",
  "Pasajeros",
  "Carga especial",
  "Mixta / variada",
  "No aplica",
];

export const serviciosOfrecidosOptions = [
  "Mudanzas",
  "Acarreo",
  "Distribución",
  "Reparto",
  "Transporte empresarial",
  "Eventos",
  "Transporte de personas",
  "Carga",
  "Logística",
  "Servicios especiales",
];

export const disponibilidadOptions = [
  { value: "disponible", label: "Disponible" },
  { value: "por_solicitud", label: "Disponible por solicitud" },
  { value: "no_disponible", label: "No disponible temporalmente" },
];

export const diasSemanaOptions = [
  "Lunes a viernes",
  "Lunes a sábado",
  "Lunes a domingo",
  "Fin de semana",
  "Días específicos",
  "Por solicitud",
];

export const documentosVehiculoOptions = [
  "Matrícula",
  "Seguro",
  "Inspección",
  "Otros documentos",
];

export const documentosPersonalesOptions = ["Licencia de conducir", "Cédula de identidad"];

export const ACCEPTED_DOC_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
];

export const MAX_DOC_SIZE = 8 * 1024 * 1024;
export const MAX_PHOTO_SIZE = 6 * 1024 * 1024;